/*****************************************************************************************************
 * Load Libraries
 */

require('bootstrap/js/src/tab.js');

/*****************************************************************************************************
 * Load All Internal Components
 */
Vue.component('subscription-form', require('@RESOURCES/js/components/subscription/SubscriptionForm').default);
Vue.component('fake-checkbox', require('@RESOURCES/js/components/FakeCheckboxComponent.vue').default);
Vue.component('signup-form', require('@RESOURCES/js/components/signupForm/SignUpForm.vue').default);
Vue.component('oplist-signup-form', require('@RESOURCES/js/components/signupForm/OplistSignupForm.vue').default);
Vue.component('single-offer-export-endpoint', require('@RESOURCES/js/components/SingleOfferExportEndpoint').default);
Vue.component('region-header', require('@RESOURCES/js/components/RegionHeader').default);
Vue.component('no-state-offer', require('@RESOURCES/js/components/operator_list/NoStateOffer.vue').default);
Vue.component('show-more-show-less-button', require('@RESOURCES/js/components/operator_list/ShowMoreShowLessButton.vue').default);